module.exports = __webpack_public_path__ + "static/virksomheder-283c62ec18cf1ddd2dab23985f0d4e0e.mp4";